import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { Home } from './pages/Home'
import { About } from './pages/About'
import { DEFAULT_LANGUAGE, createLocalizedPath } from './utils/i18n'
import './index.css'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <Routes>
        {/* Redirect root to default language */}
        <Route path="/" element={<Navigate to={createLocalizedPath('/')} replace />} />
        <Route path={`/${DEFAULT_LANGUAGE}/`} element={<Home />} />
        <Route path={`/${DEFAULT_LANGUAGE}/about`} element={<About />} />
      </Routes>
    </BrowserRouter>
  </StrictMode>,
)

// Signal that the app is ready for prerendering
if (typeof window !== 'undefined') {
  document.dispatchEvent(new Event('render-event'))
}
